import RequestHelper from "./request_helper"

// Posts a create modal's form as JSON and passes the record under `key` to onCreated.
// Errors show as a toast and leave the modal open. Use keepDisabled when success leaves the page.
export default function createFromModal(event, { modal, key, onCreated, keepDisabled = false }) {
  event.preventDefault()

  const button = event.currentTarget
  const form = document.querySelector(`${modal} form`)
  const fields = {}

  for (const [name, value] of new FormData(form)) {
    const match = name.match(/^\w+\[(\w+)\]$/)

    if (match) {
      fields[match[1]] = value.trim()
    }
  }

  const options = RequestHelper.defaultPostOptions()
  options.headers = Object.assign({}, options.headers, {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  })
  options.body = JSON.stringify({ [key]: fields })

  button.disabled = true

  return fetch(form.getAttribute("action"), options)
    .then((response) => response.json().then((data) => {
      if (!response.ok) {
        throw new Error(data.message || "Something went wrong. Please try again.")
      }

      return data[key]
    }))
    .then((record) => {
      onCreated(record, form)
      return true
    })
    .catch((error) => {
      window.ltAlert({ message: error.message, type: "toast-error" })
      button.disabled = false
    })
    .finally(() => { if (!keepDisabled) { button.disabled = false } })
}
